import { cashIntoTypeEnum, billStatusEnum } from '@/enum/income'
import SignSuccess from '@/pages/income/SignSuccess'

export default [
  {
    path: '/income',
    meta: {
      title: to =>
        to.query.cashIntoType == cashIntoTypeEnum.PERSONAL
          ? '个人收益'
          : '直播间收益'
    },
    component: () => import(/* webpackChunkName: 'income' */ '@/pages/income')
  },
  {
    path: '/withdrawal',
    meta: {
      title: '提现'
    },
    component: () =>
      import(/* webpackChunkName: 'income' */ '@/pages/income/Withdrawal_v2')
  },
  {
    path: '/vzanWithdraw',
    meta: {
      title: '个人收益提现'
    },
    component: () =>
      import(
        /* webpackChunkName: 'vzanWithdraw' */ '@/pages/income/vzanWithdraw'
      )
  },
  {
    path: '/withdrawal-success',
    meta: {
      title: '提示'
    },
    component: () =>
      import(
        /* webpackChunkName: 'income' */ '@/pages/income/WithdrawalSuccess'
      )
  },
  {
    path: '/nodrawal',
    meta: {
      title: '不可提现金额明细'
    },
    component: () =>
      import(/* webpackChunkName: 'income' */ '@/pages/income/NoDrawal')
  },
  {
    path: '/unsettled-detail',
    meta: {
      title: to =>
        to.query.billState == billStatusEnum.PENDING
          ? '发放中金额明细'
          : '我的分销收益'
    },
    component: () =>
      import(/* webpackChunkName: 'income' */ '@/pages/income/UnsettledDetail')
  },
  {
    path: '/withdrawal-detail',
    meta: {
      title: to =>
        to.query.cashIntoType == cashIntoTypeEnum.PERSONAL
          ? '个人银行卡提现明细'
          : '直播间银行卡提现明细'
    },
    component: () =>
      import(/* webpackChunkName: 'income' */ '@/pages/income/WithdrawalDetail')
  },
  {
    path: '/income-detail',
    meta: {
      title: to =>
        to.query.cashIntoType == cashIntoTypeEnum.PERSONAL
          ? '个人收益明细'
          : '直播间收益明细'
    },
    component: () =>
      import(/* webpackChunkName: 'income' */ '@/pages/income/IncomeDetail')
  },
  {
    path: '/red-packet-history',
    meta: {
      title: '我的红包'
    },
    component: () =>
      import(/* webpackChunkName: 'income' */ '@/pages/income/RedPacketHistory')
  },
  {
    path: '/sign-success',
    meta: {
      title: '提示',
      whiteList: true
    },
    component: SignSuccess
  }
]
